import { ROLE_PERMISSIONS } from "../shared/constants/Permissions";
import { roles } from "../shared/constants/Constants";

export const RBAC = {
  [roles.ADMIN]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.DM_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.VA_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.REQUESTS.SCHEME_CHANGE_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_ISSUE_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_EXPIRY_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATUS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ALTERNATE_PHONE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_UBER_ID]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.UBER_ID_STAGE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_LICENCE_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_IFSC_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CHEQUE_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_1]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_2]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.LANDMARK]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PIN_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CITY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_PROOF_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.FIRST_NAME]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LAST_NAME]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.PHONE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.EMAIL]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LEAD_SOURCES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.SUB_LEAD_CATEGORY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LANGUAGES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CAR_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.TELECALLING_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PRODUCT_TYPE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_SETTLEMENT_STATEMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.TRIP_ACTIVITY_REPORT.TRIP_ACTIVITY_REPORT]: true,
  },
  [roles.DRIVER_MANAGER]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.REQUESTS.SCHEME_CHANGE_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CAR_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.TELECALLING_ALLOCATION]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.TRIP_ACTIVITY_REPORT.TRIP_ACTIVITY_REPORT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CHILD_HUB_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.CLICK_TO_CALL]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_SETTLEMENT_STATEMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,
  },
  [roles.FINANCE]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_SETTLEMENT_STATEMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
  },
  [roles.HUB_MANAGER]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.DM_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.VA_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.REQUESTS.SCHEME_CHANGE_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CAR_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.TELECALLING_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.TRIP_ACTIVITY_REPORT.TRIP_ACTIVITY_REPORT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CHILD_HUB_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PRODUCT_TYPE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_ISSUE_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_EXPIRY_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATUS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ALTERNATE_PHONE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_UBER_ID]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.UBER_ID_STAGE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_LICENCE_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_IFSC_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CHEQUE_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_1]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_2]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.LANDMARK]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PIN_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CITY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_PROOF_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.FIRST_NAME]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LAST_NAME]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.PHONE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.EMAIL]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LEAD_SOURCES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.SUB_LEAD_CATEGORY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LANGUAGES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_SETTLEMENT_STATEMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
  },
  [roles.ONBOARDING]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.ONETIME_DM_ALLOCATION]: true,
    // [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.ONETIME_VA_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CAR_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.ONETIME_TELECALLING_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_PRODUCT_TYPE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVING_LICENCE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONTEIME_DRIVING_LICENCE_ISSUE_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVING_LICENCE_EXPIRY_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_AADHAR_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_STATUS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_ALTERNATE_PHONE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVER_UBER_ID]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_UBER_ID_STAGE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVING_LICENCE_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVER_LICENCE_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_DRIVER_SELFIE_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_AADHAR_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_AADHAR_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_BANK_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_BANK_IFSC_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_PAN_CARD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_CHEQUE_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_BANK_PASSBOOK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_PAN_CARD_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_CURRENT_ADDRESS_LINE_1]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_CURRENT_ADDRESS_LINE_2]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_LANDMARK]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_PIN_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_STATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_CITY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_ADDRESS_PROOF]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_CURRENT_ADDRESS_PROOF_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_ADDRESS_PROOF_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.ONETIME_EMAIL]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.ONETIME_LEAD_SOURCES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.ONETIME_SUB_LEAD_CATEGORY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.ONETIME_LANGUAGES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_UBER_ID]: true,
    // [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_ONBOARDING_REMARKS]:true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PRODUCT_TYPE]: true,

    //fleet docs
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,

    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,

    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.VA_ALLOCATION]: true,
  },
  [roles.PARKING]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,

    // [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: false,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
  },
  [roles.PROCUREMENT]: {
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
  },
  [roles.RECOVER_AGENT]: {},
  [roles.SENIOR_DRIVER_MANAGER]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.DM_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.VA_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.REQUESTS.SCHEME_CHANGE_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.CAR_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.TELECALLING_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.TRIP_ACTIVITY_REPORT.TRIP_ACTIVITY_REPORT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.ONETIME_CHILD_HUB_ALLOCATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_SETTLEMENT_STATEMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.SEND_DISCOUNT_REQUEST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_UBER_ID]: true,
  },
  [roles.VENDOR]: {},
  [roles.VERIFICATION]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE?.REMARKS?.COMMON_REMARKS]: true,
    [ROLE_PERMISSIONS?.DRIVER_DETAIL_PAGE?.ALLOCATIONS_COLLAPSE?.FETCH_AGENTS_LIST]: true,
  },
  [roles.TELECALLING]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.STATUS.TELECALLING_PAYMENT_STATUS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_ISSUE_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_EXPIRY_DATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATUS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ALTERNATE_PHONE_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_UBER_ID]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.UBER_ID_STAGE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_LICENCE_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_IFSC_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CHEQUE_ACCOUNT_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_1]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_LINE_2]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.LANDMARK]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PIN_CODE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.STATE]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CITY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.CURRENT_ADDRESS_PROOF_NUMBER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING_REMARKS]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_FRONT_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVING_LICENCE_BACK_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_SEND_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_RESEND_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_OFFLINE_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.AGREEMENT_HISTORY_BUTTON]: false,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LANGUAGES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.SUB_LEAD_CATEGORY]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.LEAD_SOURCES]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.DRIVER_DETAILS.EMAIL]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONETIME_PRODUCT_TYPE]: true,

    // LEAD DETAILS PAGE
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.CALL_HISTORY_BUTTON]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.WALKINDONE_BUTTON]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.CALL_BUTTON]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.HANGUP_BUTTON]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DISPOSED_BUTTON]: true,

    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.FIRST_NAME]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.LAST_NAME]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.DISPOSITION_CATEGORY]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.DISPOSITION]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.NEXT_VISIT_DATE]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.NEXT_FOLLOWUP_DATE]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.UBER_ID]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.AADHAR_NUMBER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.DRIVING_LICENSE_NUMBER]: true,

    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.LASTEST_CALL_REASON]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.TAG]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.HUB_ID]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.LEAD_DETAILS.LATEST_CALL_REMARKS]: true,

    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.AADHAR_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_FRONT_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVING_LICENCE_BACK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.DRIVER_SELFIE_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.PAN_CARD_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.BANK_PASSBOOK_PIC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_UPLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_VIEW]: true,
    [ROLE_PERMISSIONS.LEAD_DETAIL_PAGE.DOCUMENTS.ADDRESS_PROOF_PIC_ADD_ANOTHER]: true,
  },
  [roles?.FLEET_MANAGER]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
  },
  [roles?.FLEET_GENERAL_MANAGER]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ALLOCATIONS_COLLAPSE.FETCH_AGENTS_LIST]: true,
  },
  [roles?.COMMERCIAL]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.PAYMENT.PAYMENT]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,
  },
  [roles.PROCUREMENT_ADMIN]: {
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.ONBOARDING.ONBOARDING]: true,
    [ROLE_PERMISSIONS.DRIVER_DETAIL_PAGE.VERIFICATION.VERIFICATION]: true,

    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.FITNESS_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.AUTHORISATION_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.TAX_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.RC_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PDI_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INSURANCE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.PERMIT_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_ADD_ANOTHER]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.INVOICE_DOC_VIEW]: true,
  },
  [roles.HUB_PROCUREMENT]: {
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_VIEW]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_DOWNLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_UPLOAD]: true,
    [ROLE_PERMISSIONS.FLEET_DETAIL_PAGE.PARKING.POLLUTION_DOC_ADD_ANOTHER]: true,
  },
};
export const HAS_ROLE_PERMISSION = (role, permission) => {
  if (!role) return false;
  if (!permission) return false;
  if (!RBAC.hasOwnProperty(role)) {
    return false;
  }
  if (!RBAC[role]) return false;
  return RBAC[role][permission] || false;
};
